<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const props = defineProps({
  template: { type: Object, default: () => ({}) },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const dialogRef = ref(null);

const description = computed(() =>
  t('INBOX_MGMT.MESSAGE_TEMPLATES.DELETE.DESCRIPTION', {
    templateName: props.template?.name,
  })
);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('INBOX_MGMT.MESSAGE_TEMPLATES.DELETE.TITLE')"
    :description="description"
    :confirm-button-label="t('INBOX_MGMT.MESSAGE_TEMPLATES.DELETE.CONFIRM')"
    :is-loading="isLoading"
    @confirm="emit('confirm')"
  />
</template>
